import { useMutation } from '@tanstack/react-query'
import { requestPasswordReset } from '@/services/api/auth'

const REQUEST_PASSWORD_RESET_MUTATION_KEY = ['mutation', 'auth', 'requestPasswordReset'] as const

/** Requests a password-reset email. Not offline-replayable. */
export function useRequestPasswordReset() {
  return useMutation({
    mutationKey: REQUEST_PASSWORD_RESET_MUTATION_KEY,
    mutationFn: (email: string) => requestPasswordReset(email),
  })
}
